module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kk-Ld.a586e606.png";